module.exports = "/assets/1fbd343049671637c69c02b5d441a469.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V4.png
// module id = 3032
// module chunks = 0